/**
 * "Meine Tickets" als Seite unter `/tickets` (#1169).
 *
 * Dieselbe Reporter-Ansicht wie in Cortex → Bug-Reports (Liste, Verlauf,
 * Antworten, Anhang-Vorschau), nur ohne Desktop: wer ausschließlich `/chat`
 * nutzt, sieht hier die Antworten des Teams auf seine Meldungen. Der offene
 * Report steht in der Query (`/tickets?reportId=…`) — das Ziel der
 * Benachrichtigungen im Standalone-Betrieb.
 */
import { Suspense, lazy, useCallback } from 'react'
import { Loader2 } from 'lucide-react'
import { useAppHost } from '@/hooks/useAppHost'

const MyBugReportsTab = lazy(() =>
  import('@/components/bug-reports/MyBugReportsTab').then((m) => ({ default: m.MyBugReportsTab })),
)

export function StandaloneTicketsPage() {
  const host = useAppHost()
  const reportId = typeof host.params.reportId === 'string' && host.params.reportId ? host.params.reportId : null
  const { setParams } = host

  const onReportIdChange = useCallback((id: string | null) => setParams({ reportId: id ?? undefined }), [setParams])

  return (
    <div className="app-surface flex h-full flex-col overflow-hidden" data-testid="standalone-tickets-page">
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin motion-reduce:animate-none text-[var(--text-secondary)]" />
          </div>
        }
      >
        <MyBugReportsTab variant="page" reportId={reportId} onReportIdChange={onReportIdChange} />
      </Suspense>
    </div>
  )
}
